@if (!inSetupMode && !betaStringId) {
  <div class="fui-layout-container">
    <fui-layout-header [breadcrumbs]="breadcrumbs" [headingText]="'fui-header.fender_studio_pro_community'" [description]="'newdash.fender_community_description'">
      <div class="fui-nav-pills m-t-30">
        <ul>
          <li>
            <button
              [class.active]="displayedSection == 'channels'"
              (click)="appService.mobileMenuShown = false; showChannel('general', true)"
              (keyup.enter)="appService.mobileMenuShown = false; showChannel('general', true)"
              (keyup.space)="appService.mobileMenuShown = false; showChannel('general', true)"
            >
              {{ (showingMyChannels ? "com.my_channels" : "com.all_channels") | translate }}
            </button>
          </li>
          <!-- <li>
          <button
            [class.active]="displayedSection == 'topics'"
            (click)="appService.mobileMenuShown = false; showTopic(topics[0], true)"
            (keyup.enter)="appService.mobileMenuShown = false; showTopic(topics[0], true)"
            (keyup.space)="appService.mobileMenuShown = false; showTopic(topics[0], true)"
            >
            Topics
          </button>
        </li> -->
          <li>
            <button
              [class.active]="displayedSection == 'connect'"
              (click)="appService.mobileMenuShown = false; switchSection('connect')"
              (keyup.enter)="appService.mobileMenuShown = false; switchSection('connect')"
              (keyup.space)="appService.mobileMenuShown = false; switchSection('connect')"
            >
              {{ "com.connect" | translate }}
            </button>
          </li>
        </ul>
      </div>
    </fui-layout-header>
    @if (displayedSection == "channels") {
      <hr />
      <div class="fui-layout-pad-content">
        <fui-content-filter
          #fuiContentFilter
          [showViewOption]="false"
          [activeQuery]="query"
          [showResults]="false"
          [showSortOptionsToggle]="false"
          [searchOnlyOnEnter]="true"
          (refineClicked)="showTags = !showTags"
          [resultsCount]="totalVideos || 0"
          (clearQuery)="query = ''; search()"
          (clearFilter)="clearFilter($event); search()"
          (queryChanged)="query = $event; search()"
          (showMobileFiltersClicked)="appService.showModal(sidebarFilterModal, { size: 'lg' })"
        ></fui-content-filter>
      </div>
    }
    <hr />
  </div>
}

@if (!inSetupMode) {
  <main [class]="!betaStringId ? 'fui-layout-container' : 'column-layout-container'" #communityColumnLayoutContainer basepage="primary">
    @if (betaStringId) {
      <div class="menu animate-in-from-left" [class.mobile-shown]="appService.mobileMenuShown">
        <aside role="region" aria-label="side navigation">
          <div class="menu-top d-flex justify-content-between align-items-center">
            @if (!betaStringId) {
              <fui-heading [text]="'com.community' | translate" [level]="2" fontSize="f7"></fui-heading>
            }
            @if (betaStringId) {
              <div class="d-flex align-items-center">
                <button class="fa-button m-r-10" placement="bottom" ngbTooltip="Back to Beta Programs" [routerLink]="['/beta']">
                  <fa-icon icon="chevron-left" class="action circle-icon-btn"></fa-icon>
                </button>
                <span [routerLink]="['/beta']">
                  <fui-heading [text]="'beta.programs' | translate" [level]="2" fontSize="f7"></fui-heading>
                </span>
              </div>
            }
          </div>
          @if (!displayedChannels?.length) {
            <myp-skeleton-loader extraContainerClass="m-y-20" number="18" type="line" [useRandomWidth]="true" height="10px"></myp-skeleton-loader>
          }
          <ul class="menu-options">
            @if (displayedChannels?.length && !betaStringId && (displayedSection == "channels" || displayedSection == "search")) {
              <div class="m-r-10">
                <div class="form-group">
                  <label class="control-label" for="search-all-post">Search all posts</label>
                  <div class="product-filter m-b-20">
                    <div class="filter-input">
                      <input id="search-all-post" type="text" (keyup.enter)="search()" [(ngModel)]="query" placeholder="Enter a query ..." />
                      @if (query) {
                        <button type="button" class="border-0 btn-transparent clear p-0 bg-transparent" (click)="clear()">
                          <fa-icon icon="times" aria-hidden="true"></fa-icon>
                          <span class="sr-only">clear search</span>
                        </button>
                      }
                    </div>
                  </div>
                </div>
              </div>
            }
            @if (betaStringId) {
              <li class="menu-option" [class.active]="displayedSection == 'betadetails'">
                <a
                  class="primary-option"
                  tabindex="0"
                  href="javascript:void(0);"
                  (keyup.enter)="appService.mobileMenuShown = false; switchSection('betadetails')"
                  (keyup.space)="appService.mobileMenuShown = false; switchSection('betadetails')"
                  (click)="appService.mobileMenuShown = false; switchSection('betadetails')"
                >
                  Beta Details
                </a>
              </li>
            }
            @if (!betaStringId || betaCommunityTags?.length) {
              <li class="menu-option" [class.active]="displayedSection == 'channels'">
                <a
                  class="primary-option"
                  tabindex="0"
                  href="javascript:void(0);"
                  (keyup.enter)="appService.mobileMenuShown = false; showChannel(betaStringId ? 'all_posts' : 'general', true)"
                  (keyup.space)="appService.mobileMenuShown = false; showChannel(betaStringId ? 'all_posts' : 'general', true)"
                  (click)="appService.mobileMenuShown = false; showChannel(betaStringId ? 'all_posts' : 'general', true)"
                >
                  @if (!betaStringId) {
                    {{ (showingMyChannels ? "com.my_channels" : "com.all_channels") | translate }}
                  }
                  @if (betaStringId) {
                    Bugs & Feature Requests
                  }
                </a>
                @if (this.displayedChannels?.length && betaStringId && (displayedSection == "channels" || displayedSection == "search")) {
                  <div class="m-r-10 m-t-10">
                    <div class="product-filter m-b-20">
                      <div class="filter-input">
                        <input type="text" (keyup.enter)="search()" [(ngModel)]="query" placeholder="Search all posts..." />
                        @if (query) {
                          <button type="button" class="border-0 btn-transparent clear p-0 bg-transparent" (click)="clear()">
                            <fa-icon icon="times" aria-hidden="true"></fa-icon>
                            <span class="sr-only">clear search</span>
                          </button>
                        }
                      </div>
                    </div>
                  </div>
                }
                @if (betaStringId && displayedSection == "channels") {
                  <div class="m-r-10 m-b-20">
                    <span class="font-weight-bold t-15 p-10 d-block">Display</span>
                    <myp-segmented-bar
                      [white]="true"
                      [nowrap]="true"
                      [id]="'beta-view-segmented-bar'"
                      (selected)="selectBetaView($event.id)"
                      [options]="[
                        {
                          name: 'Detailed',
                          id: 'detailed',
                          selected: selectedBetaView == 'detailed',
                        },
                        {
                          name: 'List',
                          id: 'list',
                          selected: selectedBetaView == 'list',
                        },
                      ]"
                    ></myp-segmented-bar>
                    <span class="font-weight-bold t-15 p-10 d-block m-t-20">Sorting</span>
                    <select class="form-control custom-select-sm m-r-10" (change)="filter()" [(ngModel)]="filters.sort">
                      <option value="date">Newest</option>
                      <!-- <option value="activity">Most Replies</option> -->
                      <option value="recentactivity">Recent Replies</option>
                    </select>
                    <span class="font-weight-bold t-15 p-10 d-block m-t-20">Filters</span>
                    <select class="form-control custom-select-sm m-r-10" (change)="filter()" [(ngModel)]="filters.type">
                      <option value="all">All Post Types</option>
                      <option value="bug">Bugs</option>
                      <option value="feature_request">Feature Requests</option>
                      <option value="post">Posts</option>
                    </select>
                    <select class="form-control custom-select-sm m-r-10 m-t-10" (change)="filter()" [(ngModel)]="filters.status">
                      <option value="all">Any Status</option>
                      <option value="open">Open</option>
                      <option value="cannot_reproduce">Cannot Reproduce</option>
                      <option value="fixed">Fixed</option>
                      <option value="investigating">Investigating</option>
                      <option value="accepted">Accepted</option>
                      <option value="rejected">Rejected</option>
                    </select>
                    <select class="form-control custom-select-sm m-r-10 m-t-10 m-b-10" (change)="filter()" [(ngModel)]="filters.reviewStatus">
                      <option value="all">Reviewed & Not Reviewed</option>
                      <option value="true">Only Reviewed</option>
                      <option value="false">Only Not Reviewed</option>
                    </select>
                    @if (communityService.betaAuthorList?.length) {
                      <select class="form-control custom-select-sm m-r-10 m-t-10 m-b-10" (change)="filter()" [(ngModel)]="filters.author">
                        <option value="all">Any Author</option>
                        @for (author of communityService.betaAuthorList; track author) {
                          <option [value]="author.id">{{ author.name }}</option>
                        }
                      </select>
                    }
                    <input class="form-control custom-select-sm m-r-10 m-t-10 m-b-10" placeholder="Jira Ticket Number" type="text" (keyup.enter)="filter()" [(ngModel)]="filters.jiraTicketNumber" />
                    <button class="btn btn-primary btn-sm" (click)="resetFilters()">Reset Filters</button>
                  </div>
                }
                @if (displayedChannels && displayedChannels.length) {
                  <div class="menu-suboptions">
                    @for (channel of displayedChannels; track channel) {
                      <div class="sub-option d-block">
                        <a
                          tabindex="0"
                          href="javascript:void(0);"
                          (keyup.enter)="showChannel(channel, true)"
                          (keyup.space)="showChannel(channel, true)"
                          [class.active]="displayedSection == 'channels' && selectedChannel && selectedChannel.title == channel.title"
                          (click)="appService.mobileMenuShown = false; showChannel(channel, true)"
                        >
                          {{ channel.string_id != "general" && channel.string_id != "all_posts" && channel.string_id != "pinned_posts" && channel.string_id != "my_posts" ? "#" : "" }}
                          {{ betaStringId ? channel.title : ("com.skills." + channel.string_id | translate) }}
                          @if (betaStringId && communityService.betaTagCountMap && communityService.betaTagCountMap[channel.string_id]) {
                            <span class="badge">
                              {{
                                channel.string_id != "general" && channel.string_id != "all_posts" && channel.string_id != "pinned_posts" && channel.string_id != "my_posts"
                                  ? communityService.betaTagCountMap[channel.string_id]
                                  : ""
                              }}
                            </span>
                          }
                        </a>
                      </div>
                    }
                    <div class="m-l-10">
                      @if (mySkills && mySkills.length) {
                        <button class="small-btn" (click)="toggleChannels()">{{ (showingMyChannels ? "com.show_all" : "com.show_mine") | translate }}</button>
                      }
                      @if (user.active_subscription && !betaStringId) {
                        <button class="small-btn" (click)="addSkill()">{{ "general.manage" | translate }}</button>
                      }
                    </div>
                  </div>
                }
              </li>
            }
            @if (allTopics && allTopics.length) {
              <li class="menu-option" [class.active]="displayedSection == 'topics'">
                @if (topics.length || user.is_sphere_admin) {
                  <a
                    class="primary-option"
                    tabindex="0"
                    href="javascript:void(0);"
                    (keyup.enter)="appService.mobileMenuShown = false; showTopic(topics[0], true)"
                    (keyup.space)="appService.mobileMenuShown = false; showTopic(topics[0], true)"
                    (click)="appService.mobileMenuShown = false; showTopic(topics[0], true)"
                  >
                    Topics
                  </a>
                }
                <div class="menu-suboptions">
                  @for (topic of showingAllTopics ? allTopics : topics; track topic) {
                    <div class="sub-option d-block">
                      <a
                        tabindex="0"
                        href="javascript:void(0);"
                        (keyup.enter)="showTopic(topic, true)"
                        (keyup.space)="showTopic(topic, true)"
                        [class.archived]="topic.archived"
                        [class.active]="displayedSection == 'topics' && selectedTopic && selectedTopic?.title == topic.title"
                        (click)="appService.mobileMenuShown = false; showTopic(topic, true)"
                      >
                        {{ topic.title }}
                        @if (topic.archived) {
                          <span class="tiny-pill">ARCHIVED</span>
                        }
                      </a>
                    </div>
                  }
                  @if (user.is_sphere_admin) {
                    <div class="m-l-10">
                      <a [routerLink]="['/admin/community_topics']" class="small-btn m-r-10">Manage Topics</a>
                      @if (user.active_subscription && allTopics.length > topics.length) {
                        <button class="small-btn" (click)="showingAllTopics = !showingAllTopics">{{ showingAllTopics ? "Hide" : "View" }} Archived Topics</button>
                      }
                    </div>
                  }
                </div>
              </li>
            }
            @if (!betaStringId) {
              <li class="menu-option" [class.active]="displayedSection == 'connect'">
                <a
                  class="primary-option"
                  tabindex="0"
                  href="javascript:void(0);"
                  (keyup.enter)="appService.mobileMenuShown = false; switchSection('connect')"
                  (keyup.space)="appService.mobileMenuShown = false; switchSection('connect')"
                  (click)="appService.mobileMenuShown = false; switchSection('connect')"
                >
                  {{ "com.connect" | translate }}
                </a>
              </li>
            }
          </ul>
        </aside>
      </div>
    }
    @if (!betaStringId) {
      <div class="fui-sidebar-content-container">
        @if (showTags && displayedSection == "channels") {
          <div class="fui-sidebar-filter sticky">
            <ng-container *ngTemplateOutlet="filterContent"></ng-container>
            <button class="small-btn m-t-30" (click)="fuiContentFilter.refine()">
              <fa-icon icon="chevron-left"></fa-icon>
              Hide Filters
            </button>
          </div>
        }
        <ng-container *ngTemplateOutlet="mainCommunityContent"></ng-container>
      </div>
    }
    @if (betaStringId) {
      <ng-container *ngTemplateOutlet="mainCommunityContent"></ng-container>
    }
    <ng-template #mainCommunityContent>
      <section
        [class]="!betaStringId ? 'fui-layout-pad-content m-t-30' : 'content animate-in-from-right'"
        [class.fui-sidebar-shown]="showTags && displayedSection == 'channels'"
        #contentContainer
        (scroll)="contentContainerScrolled($event)"
        [class.mobile-shown]="!appService.mobileMenuShown"
      >
        @if (betaStringId) {
          <button class="mobile-back-btn no-border" (click)="appService.mobileMenuShown = true">
            <fa-icon icon="chevron-left"></fa-icon>
            @if (!betaStringId) {
              {{ "com.community" | translate }}
            }
            @if (betaStringId) {
              Beta Options
            }
          </button>
        }
        <div>
          @if (displayedSection == "search") {
            <myp-community-search
              [betaStringId]="betaStringId"
              #searchCmp
              [query]="selectedQuery"
              (scrollToTop)="scrollToTop()"
              (postsLoaded)="postsLoaded()"
              (viewPost)="showPostDetail($event)"
              (clearSearch)="clear()"
            ></myp-community-search>
          }
        </div>
        @if (!shouldShowPostDetails) {
          <div>
            @if (displayedSection == "betadetails" && betaProgram) {
              <myp-beta-details [betaProgram]="betaProgram"></myp-beta-details>
            }
            @if (displayedSection == "connect") {
              <myp-connect (membersSearched)="showMemberResults($event)" [skills]="skills"></myp-connect>
            }
            <!-- <myp-inline-loader [loading]="loading" height="400px" spinnerName="postLoader"></myp-inline-loader> -->
            @if (postsLoading) {
              <div style="width: 200px">
                <myp-skeleton-loader type="line" height="40px" width="100%"></myp-skeleton-loader>
              </div>
              <div>
                <myp-skeleton-loader extraContainerClass="m-t-20 m-b-30" max="100%" borderRadius="10px" type="carousel" height="100px"></myp-skeleton-loader>
                <myp-skeleton-loader extraContainerClass="m-y-40" max="100%" borderRadius="10px" type="carousel" height="300px"></myp-skeleton-loader>
                <myp-skeleton-loader extraContainerClass="m-y-40" max="100%" borderRadius="10px" type="carousel" height="100px"></myp-skeleton-loader>
                <myp-skeleton-loader extraContainerClass="m-y-40" max="100%" borderRadius="10px" type="carousel" height="200px"></myp-skeleton-loader>
                <myp-skeleton-loader extraContainerClass="m-y-40" max="100%" borderRadius="10px" type="carousel" height="340px"></myp-skeleton-loader>
              </div>
            }
            @if (displayedSection == "channels" && selectedChannel && betaStringId) {
              <div class="community-post beta-header">
                This is the Beta Community for:
                <br />
                <fui-heading [text]="betaProgram.title" [level]="2" textAlign="center" fontSize="f8"></fui-heading>
              </div>
            }
            @if (displayedSection == "channels" && selectedChannel && betaStringId) {
              @if (betaAnnouncements?.length) {
                <div>
                  <div class="section-header m-t-20">
                    <fui-heading [text]="'Announcements'" [level]="2" fontSize="f7"></fui-heading>
                    <span class="section-header-link" (click)="announcementsCollapsed = !announcementsCollapsed">
                      {{ announcementsCollapsed ? ("sphere.expand" | translate) : ("sphere.collapse" | translate) }}
                      <fa-icon [icon]="announcementsCollapsed ? 'chevron-down' : 'chevron-up'"></fa-icon>
                    </span>
                  </div>
                  @if (!announcementsCollapsed) {
                    <div class="m-t-20">
                      @for (ann of betaAnnouncements; track ann) {
                        <myp-comment
                          [betaStringId]="betaStringId"
                          [comment]="ann"
                          [isCommunityPost]="true"
                          [replies]="communityService.activeParentThreadMap[ann.key]"
                          (replied)="sendReply($event)"
                          (deleteIndexSet)="postDeleteIndex = $event"
                          [index]="i"
                          (channelSelected)="channelSelected($event)"
                          [displayedSection]="postType"
                        ></myp-comment>
                      }
                    </div>
                  }
                  @if (announcementsCollapsed) {
                    <div class="text-muted m-b-20">{{ betaAnnouncements.length }} Announcement{{ betaAnnouncements.length > 1 ? "s" : "" }} Hidden.</div>
                  }
                </div>
              }
            }
            @if ((displayedSection == "channels" && selectedChannel) || (displayedSection == "topics" && selectedTopic)) {
              <myp-channel
                #channelCmp
                (postsLoaded)="postsLoaded($event)"
                [postType]="displayedSection"
                (channelSelected)="channelSelected($event)"
                (resetFilters)="resetFilters()"
                [selectedChannel]="selectedChannel"
                (topicSelected)="displayedSection = 'topics'; selectedChannel = undefined; selectedTopic = webCommunityService.topicMap[$event]"
                [selectedTopic]="selectedTopic"
                [betaStringId]="betaStringId"
                [selectedBetaView]="selectedBetaView"
              ></myp-channel>
            }
          </div>
        }
      </section>
    </ng-template>
  </main>
}

@if (inSetupMode) {
  <main basepage="primary" class="fullwidth-layout-container h-full">
    <div class="d-flex align-items-center justify-content-center h-full">
      <div class="text-center position-relative" style="max-width: 800px">
        @if (setupStep == "init") {
          <div class="position-relative">
            <div>
              <div>
                <!-- <span class="">{{ "sphere.welcome.welcome_to" | translate }}</span
                ><br /> -->
                <!-- <img class="pointer text-logo" style="width: 200px" src="./assets/images/s1+black.png" /><br /> -->
                <h1 class="t-50 bold brandfont-black" style="font-size: 40px">{{ "sphere.welcome.welcome_to" | translate }} {{ env.studioOnePlusBrandName }} {{ "com.community" | translate }}</h1>
              </div>
              <!-- <img src="./assets/images/community-horizon-flare2.png" style="width: 100%; max-width: 600px" /> -->
            </div>
          </div>
          <div class="position-relative" style="z-index: 999">
            <div class="community-onboarding-box">
              <span>{{ "com.onboarding.com_lets_you" | translate }}</span>
              <div class="m-y-50">
                <span class="bold">{{ "com.onboarding.step1" | translate }}</span>
                <div [innerHTML]="'com.onboarding.to_interact' | translate | safe: 'html'"></div>
                <br />
                <small class="text-muted">{{ "com.onboarding.decide_hidden" | translate }}</small>
              </div>
              <button class="btn btn-primary m-t-10 d-inline-block" (click)="setProfile(true)">
                {{ "com.onboarding.turn_it_on" | translate }}
                <fa-icon class="btn-primary" icon="check"></fa-icon>
              </button>
              <br />
              <br />
              <button class="tiny-link black m-t-10 d-inline-block" (click)="setProfile(false)">
                {{ "com.onboarding.keep_me_hidden" | translate }}
                <fa-icon icon="times"></fa-icon>
              </button>
            </div>
          </div>
        }
        @if (setupStep == "extra_details") {
          <div class="community-onboarding-box">
            <h1 class="bold">{{ "com.onboarding.step2" | translate }}</h1>
            <div class="row">
              @if (!user.firstName) {
                <div class="form-group col-md-6">
                  <small class="text-muted">{{ "profile.edit.first_name" | translate }}</small>
                  <input type="text" class="form-control" name="firstName" id="firstName" [(ngModel)]="profile.firstName" [placeholder]="'profile.edit.enter_name' | translate" />
                </div>
              }
              @if (!user.lastName) {
                <div class="form-group col-md-6">
                  <small class="text-muted">{{ "profile.edit.last_name" | translate }}</small>
                  <input type="text" class="form-control" name="lastName" id="lastName" [(ngModel)]="profile.lastName" [placeholder]="'profile.edit.enter_last_name' | translate" />
                </div>
              }
              <div class="form-group col-md-12">
                <small class="text-muted">{{ "com.tagline" | translate }}</small>
                <input type="text" class="form-control" name="tagline" id="tagline" [(ngModel)]="profile.tagline" [placeholder]="'com.enter_tagline' | translate" />
                <small class="text-muted">{{ "com.tagline_description" | translate }}</small>
              </div>
              <div class="form-group col-md-12">
                <small class="text-muted">{{ "profile.edit.description" | translate }}</small>
                <textarea name="description" id="description" [(ngModel)]="profile.description" class="form-control">{{ user.description }}</textarea>
                <small class="text-muted">{{ "com.profile_description" | translate }}</small>
              </div>
            </div>
            <br />
            <br />
            {{ "com.skills_description" | translate }}
            <br />
            <div class="text-left">
              @for (skill of mySkills; track skill) {
                <div class="list-item hover dontgrow">
                  <div class="list-item-container">
                    <div class="main-data">
                      <span class="title">{{ "com.skills." + skill.string_id | translate }}</span>
                      @if (skill.is_service || skill.notes) {
                        <span class="sub-data">
                          @if (skill.is_service) {
                            <div>{{ "com.offered_as_service" | translate }}</div>
                            <!-- <div *ngIf="skill.hourly_rate">Hourly rate: ${{ skill.hourly_rate }}</div> -->
                          }
                          @if (skill.notes) {
                            <div>{{ "com.notes" | translate }}: {{ skill.notes }}</div>
                          }
                        </span>
                      }
                    </div>
                  </div>
                </div>
              }
            </div>
            <button class="btn btn-primary m-t-10 d-inline-block" (click)="addSkill()">
              {{ (mySkills && mySkills.length ? "com.add_more_skills" : "com.add_skills") | translate }}
              <fa-icon icon="chevron-right" class="btn-primary"></fa-icon>
            </button>
            <div class="m-t-30">
              @if (!mySkills || !mySkills.length) {
                <button class="small-btn" (click)="updateProfile()">{{ "com.onboarding.do_this_later" | translate }}</button>
              }
              @if (mySkills && mySkills.length) {
                <button class="btn btn-primary" (click)="updateProfile()">{{ "sphere.welcome.continue" | translate }}</button>
              }
            </div>
          </div>
        }
        @if (setupStep == "done") {
          <div class="community-onboarding-box">
            <h1 class="brandfont-bold">{{ "com.onboarding.done" | translate }}</h1>
            <span class="text-muted">{{ "com.onboarding.heres_more" | translate }}</span>
            <ul class="row">
              <li class="m-y-20 col-md-6">
                <fa-icon icon="bullhorn" class="t-40 c-official-blue"></fa-icon>
                <fui-heading [text]="'com.posts' | translate" [level]="3" fontSize="f7" extraClasses="brandfont-bold"></fui-heading>
                <span class="text-muted">{{ "com.onboarding.posts_desc" | translate }}</span>
              </li>
              <li class="m-y-20 col-md-6">
                <fa-icon icon="guitar" class="t-40 c-official-blue"></fa-icon>
                <fui-heading [text]="'com.skills_word' | translate" [level]="3" fontSize="f7" extraClasses="brandfont-bold"></fui-heading>
                <span class="text-muted">{{ "com.onboarding.skills_desc" | translate }}</span>
              </li>
              <li class="m-y-20 col-md-6">
                <fa-icon icon="microphone" class="t-40 c-official-blue"></fa-icon>
                <fui-heading [text]="'com.showcases' | translate" [level]="3" fontSize="f7" extraClasses="brandfont-bold"></fui-heading>
                <span class="text-muted">{{ "com.onboarding.showcases_desc" | translate }}</span>
              </li>
              <li class="m-y-20 col-md-6">
                <fa-icon icon="comments" class="t-40 c-official-blue"></fa-icon>
                <fui-heading [text]="'com.connections_messages' | translate" [level]="3" fontSize="f7" extraClasses="brandfont-bold"></fui-heading>
                <span class="text-muted">{{ "com.onboarding.connections_desc" | translate }}</span>
              </li>
            </ul>
            <button class="btn btn-primary" (click)="doneSetup()">{{ "com.onboarding.lets_go" | translate }}</button>
          </div>
        }
      </div>
    </div>
  </main>
}

<div class="fui-layout-container">
  <div class="m-t-100 p-b-50">
    <fui-footer></fui-footer>
  </div>
</div>

@if (shouldShowMemberResults) {
  <myp-member-results-overlay (closeClicked)="closeMemberResults()" [searchResults]="searchResults"></myp-member-results-overlay>
}

<!-- Reusable filter content template -->
<ng-template #filterContent>
  @if (!displayedChannels?.length) {
    <myp-skeleton-loader type="line" extraContainerClass="m-y-30" [useRandomWidth]="true" number="18" height="10px"></myp-skeleton-loader>
  }
  <ul>
    @for (channel of displayedChannels; track channel) {
      <li class="fui-primary-category" [class.selected]="displayedSection == 'channels' && selectedChannel && selectedChannel.title == channel.title">
        <a
          tabindex="0"
          href="javascript:void(0);"
          (keyup.enter)="showChannel(channel, true); appService.closeModals()"
          (keyup.space)="showChannel(channel, true); appService.closeModals()"
          (click)="appService.mobileMenuShown = false; showChannel(channel, true); appService.closeModals()"
        >
          {{ channel.string_id != "general" && channel.string_id != "all_posts" && channel.string_id != "pinned_posts" && channel.string_id != "my_posts" ? "#" : ""
          }}{{ betaStringId ? channel.title : ("com.skills." + channel.string_id | translate) }}
          @if (betaStringId && communityService.betaTagCountMap && communityService.betaTagCountMap[channel.string_id]) {
            <span class="badge">
              {{
                channel.string_id != "general" && channel.string_id != "all_posts" && channel.string_id != "pinned_posts" && channel.string_id != "my_posts"
                  ? communityService.betaTagCountMap[channel.string_id]
                  : ""
              }}
            </span>
          }
        </a>
      </li>
    }
  </ul>
  @if (mySkills && mySkills.length) {
    <button class="small-btn d-block" (click)="toggleChannels()">{{ (showingMyChannels ? "com.show_all" : "com.show_mine") | translate }}</button>
  }
  @if (user.active_subscription && !betaStringId) {
    <button class="small-btn d-block m-t-10" (click)="addSkill()">{{ "general.manage" | translate }}</button>
  }
</ng-template>

<!-- Modal template for mobile filter -->
<ng-template #sidebarFilterModal let-modal>
  <div class="modal-body fui-sidebar-filter-mobile">
    <ng-container *ngTemplateOutlet="filterContent"></ng-container>
  </div>
  <div class="modal-footer">
    <button class="btn btn-primary" (click)="modal.close()">Done</button>
  </div>
</ng-template>
